import httpClient from '@xver/libs/axios';

import {
    NotificationPreferenceModel,
    UpdateNotificationPreferenceRequestModel,
    UpdateNotificationPreferenceResponseModel,
} from './model';

const ENDPOINTS = {
    GET: '/v1/users/me/notification-preferences',
    UPDATE: '/v1/users/me/notification-preferences',
};

export function getNotificationPreferences(): Promise<NotificationPreferenceModel> {
    return httpClient.get(ENDPOINTS.GET);
}

export function updateNotificationPreferences(
    payload: UpdateNotificationPreferenceRequestModel
): Promise<UpdateNotificationPreferenceResponseModel> {
    return httpClient.put(ENDPOINTS.UPDATE, payload);
}
